
import { defineComponent } from "vue";

export default defineComponent({
  name: "TitlebarButtons",
  props: {
    focused: Boolean
  },
  emits: ["update-focus", "update-maximization"],
  methods: {
    updateFocus: function() {
      this.$emit("update-focus", "");
    },
    updateMaximization: function() {
      this.$emit("update-maximization", "");
    }
  }
});
